module.exports = __webpack_public_path__ + "static/img/home_logo.b40eede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_logo.png
// module id = 5bpU
// module chunks = 1